module.exports = __webpack_public_path__ + "img/QRCode.1bc91643.png";